import axios, { AxiosResponse, CancelTokenSource, AxiosRequestConfig } from 'axios'
import { getPhpToken } from 'src/pc/utils/auth'

const { CancelToken } = axios

interface HttpOptions {
  Url: string
  Type: 'Get' | 'Post'
  OnError?(error: Error): void
}
//设置超时时间
axios.defaults.timeout = 15000
//处理网络错误message
axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error?.response) {
      // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
      error.message = error.message || '系统维护中，请稍后再试'
    } else if (error?.request) {
      // 请求已经成功发起，但没有收到响应
      error.message = '请求超时，请稍后再试'
      console.error(`请求超时，url=`, error?.config?.url)
    } else {
      // 发送请求时出了点问题
      error.message = '系统维护中，请稍后再试'
    }
    return Promise.reject(error)
  },
)

const BaseHttp = <P, R>(Options: HttpOptions) => {
  let Source: CancelTokenSource
  /**
   * 执行Http操作
   */
  const Execute = async (Params?: P, config?: AxiosRequestConfig): Promise<R> => {
    Source = CancelToken.source()
    //添加Authorization请求头
    const cfg = {
      ...{
        headers: {
          ...(getPhpToken() ? { Authorization: getPhpToken() } : {}),
          ...config?.headers,
        },
      },
      ...config,
    }
    try {
      if (Options.Type === 'Get') {
        return await HttpGet(Options.Url, Params, cfg)
      }
      return await HttpPost(Options.Url, Params, cfg)
    } catch (err) {
      if (Options.OnError) {
        Options.OnError(err)
      }
      throw err
    }
  }

  /**
   * 取消Http请求
   */
  const Cancel = () => {
    Source?.cancel()
  }

  const HttpGet = async (Url: string, params?: P, config?: AxiosRequestConfig): Promise<R> => {
    return GetResponse(
      await axios.get<R>(Url, {
        params: { ...params, origin: window.location.origin },
        ...config,
        cancelToken: Source?.token,
      }),
    )
  }

  const HttpPost = async (Url: string, params?: P, config?: AxiosRequestConfig): Promise<R> => {
    const newUrl =
      Url.indexOf('?') !== -1 ? `${Url}&origin=${window.location.origin}` : `${Url}?origin=${window.location.origin}`
    return GetResponse(await axios.post<R>(newUrl, params, { ...config, cancelToken: Source?.token }))
  }

  const GetResponse = <T>(Response: AxiosResponse<T>): T => {
    if (Response.headers['content-type'] === 'application/json') {
      return Response.data
    }
    return Response.data
  }
  return { Execute, Cancel }
}

export default BaseHttp
